import React, { useState } from 'react';
import { IoMdLink, IoMdGrid, IoIosListBox } from 'react-icons/io';

import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import ROUTES from '../../../../../../core/constants/routes.constants';
import { Link } from 'react-router-dom';
import { Typography } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../store';
import {
  exportIsBusySelector,
  exportResponseSelector,
  getSampleExportThunk,
} from '../../../../../../store/cryoboxList';
import { ReportExportStatus } from '../../../../../../core/api/lab.types';
import ExportReportButton from '../../../Storage/scenes/List/components/ExportReportButton';

function HomeOptions() {
  const dispatch = useAppDispatch();
  const exportLoading = useAppSelector(exportIsBusySelector);
  const exportResponse = useAppSelector(exportResponseSelector);
  const [exportStatus, setExportStatus] = useState('');

  const createExport = (type: ReportExportStatus) => {
    if (!exportLoading) {
      setExportStatus(type);
      dispatch(getSampleExportThunk(type));
    }
  };

  const downloadExport = () => {
    if (exportResponse?.exportLink) {
      window.open(exportResponse.exportLink, '_blank');
    }
  };

  return (
    <Box mb={2}>
      <Typography variant="h4" component="h4" paragraph>
        Management
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Button
            variant="contained"
            color="primary"
            size="xl"
            fullWidth
            component={Link}
            to={ROUTES.batchesCreate}
            startIcon={<IoMdGrid size={40} />}
          >
            Sample Processing
          </Button>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Button
            variant="contained"
            color="primary"
            size="xl"
            fullWidth
            component={Link}
            to={ROUTES.cryoboxCreate}
            startIcon={<IoIosListBox size={40} />}
          >
            Sample Storage
          </Button>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Button
            variant="contained"
            color="primary"
            size="xl"
            fullWidth
            component={Link}
            to={ROUTES.linking}
            startIcon={<IoMdLink size={40} />}
          >
            RGC Linking
          </Button>
        </Grid>
      </Grid>
      <Typography mt={3} variant="h4" component="h4" paragraph>
        Download Reports
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <ExportReportButton
            exportResponse={exportResponse}
            exportStatus={exportStatus}
            downloadExport={downloadExport}
            createExport={createExport}
            exportLoading={exportLoading}
            buttonType={ReportExportStatus.sequencing}
            buttonCreateLabel="Create Sequencing Shipment Report"
            buttonDownloadLabel="Download Sequencing Shipment Report"
            buttonTestId="downloadSequencerReport"
            tooltip="Download locations of WHOLE BLOOD samples for sequencing shipment. Eligibility requires EHR received + enrolled; duplicates, orphan samples, biobanked aliquots, Do Not Ship, and withdrawn samples are marked ineligible."
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <ExportReportButton
            exportResponse={exportResponse}
            exportStatus={exportStatus}
            downloadExport={downloadExport}
            createExport={createExport}
            exportLoading={exportLoading}
            buttonType={ReportExportStatus.storage}
            buttonCreateLabel="Create Storage Shipment Shipment Report"
            buttonDownloadLabel="Download Storage Shipment Report"
            buttonTestId="downloadStorageReport"
            tooltip="Download locations of PLASMA and SERUM samples for storage shipment. Eligibility based on enrolment status (withdrawn samples included but marked ineligible)."
          />
        </Grid>
      </Grid>
      <Typography mt={3} variant="h4" component="h4" paragraph>
        Search
      </Typography>
    </Box>
  );
}

export default HomeOptions;
